import { ITravelFlightAirline } from '@shared/shared/interfaces/travel-flight.interfaces';
import * as fromActions from '../actions/flight-airlines.actions';

export const initialState: Array<ITravelFlightAirline> = [];

export function reducer(state = initialState, action: fromActions.FlightAirlinesActions): Array<ITravelFlightAirline> {
  switch (action.type) {
    case fromActions.GET_ALL_FLIGHT_AIRLINES_SUCCESS:
      return action.payload.map((item) => {
        return {
          ...item,
          id: parseInt(item.search_id, 10),
        };
      });
    default:
      return state;
  }
}
